export default class RichText {
	constructor() {

		this.editorImages = document.querySelectorAll('.rich-text img');
		this.editorImages.forEach((img) => {
			let link = img.closest('a');
			if (link && link.getAttribute('target') !== "_blank") {
				link.classList.add('image-pswp');
				link.setAttribute('data-pswp-src', img.src);
				link.setAttribute('data-pswp-width', img.getAttribute('width'));
				link.setAttribute('data-pswp-height', img.getAttribute('height'));
				link.setAttribute('data-pswp-alt', img.getAttribute('alt'));
			}
		});

		// Le style "Sur-titre" de TinyMCE ne produit qu'un <p class="tag"> : on complète ici
		// avec le balisage tag-dot/tag-label attendu par partials/_tag.scss (impossible à
		// obtenir depuis le sélecteur de styles de l'éditeur, qui ne crée pas de sous-éléments).
		this.editorTags = document.querySelectorAll('.rich-text .tag');
		this.editorTags.forEach((tag) => {
			if (tag.querySelector('.tag-dot')) return;

			const dot = document.createElement('span');
			dot.className = 'tag-dot';

			const label = document.createElement('span');
			label.className = 'tag-label';
			label.innerHTML = tag.innerHTML;

			tag.innerHTML = '';
			tag.append(dot, label);
		});
	}
}
